import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { PACKAGES, ADD_ONS, CONTACT_PHONE, CONTACT_EMAIL } from "@/constants/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_CONFIG = {
  packages: PACKAGES,
  add_ons: ADD_ONS,
  contact: { phone: CONTACT_PHONE, email: CONTACT_EMAIL },
};

const SiteConfigContext = createContext(null);

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/site-config`);
      setConfig(data);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh().catch(() => {});
  }, [refresh]);

  const save = async (next) => {
    const { data } = await axios.put(`${API}/site-config`, next, { withCredentials: true });
    setConfig(data);
    return data;
  };

  const reset = async () => {
    const { data } = await axios.post(`${API}/site-config/reset`, {}, { withCredentials: true });
    setConfig(data);
    return data;
  };

  const value = useMemo(
    () => ({ config, loaded, refresh, save, reset }),
    [config, loaded, refresh],
  );

  return (
    <SiteConfigContext.Provider value={value}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
export default SiteConfigContext;
